export const API_SUCCESS_STATUS_CODE = 0;
export const HTTP_API_SUCCESS_STATUS_CODE = 200;
export const DEFAULT_API_RETRY_DELAY_TIME_IN_MS = 100;
